import React from 'react';
import { AppHeader } from "../header/AppHeader";
import './UnauthorizedPage.less';
import { ReactComponent as AccessDeniedIcon } from '../../assets/AccessDeniedIcon.svg';
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import HomeIcon from '@mui/icons-material/Home';
import { authController } from '@reedexpo/authorization-component-ui';

export const UnauthorizedPage = () => {
  const {t} = useTranslation();
  const config = window['authSettings'];

  const onLogoutClick = () => {
    authController.initialize(config);
    authController.logout('/');
  }

  return <div className={'unauth-wrapper'}>
    <AppHeader hideOptions/>

    <div className={'unauth-content'}>
      <AccessDeniedIcon width={103} height={96}/>

      <div className={"unauth-title"}>
        {t('common:accessDenied.title')}
      </div>
      <div className={"unauth-subtitle"}>
        {t('common:accessDenied.subtitle')}
      </div>

      <Button
        color={'primary'}
        variant={'contained'}
        size={'small'}
        className={'unauth-button'}
        onClick={onLogoutClick}
      >
        <div>
          <HomeIcon fontSize={'small'}/>
          <span>{t('common:accessDenied.buttonLabel')}</span>
        </div>
      </Button>
    </div>
  </div>;
};
